/*jslint regexp: true */

/**
 * A reusable dropdown plugin for jQuery
 * Allows the user to choose from a list of options or type a custom option
 */
(function ($) {
   "use strict";

   var methods = {
         /**
          * Create the dropdown
          *   list - The source data. Either an object or an array.
          * Required options:
          *   type - The type of element to display. Either "text" or "combo". Default is "text"
          *   textHint - The text the user sees if nothing is entered
          * Optional options: 
          *   dropdownClass - An additional class for the dropdown
          *   inputClass - An additional class for the select box
          *   formatter - A function that accepts what the user typed and returns the value
          *               and text to display in the select box
          *   onBlurAndChange - A function called when the user has changed the value and left focus
          */
         init: function (list, config) {
            return this.each(function () {
               var jHiddenInput = $(this),
                  data = jHiddenInput.data('c21textdropdown'),
                  options = $.extend({
                     type: "text"
                  }, config);

               // If the plugin hasn't been initialized yet
               if (!data) {
                  data = {};
                  var m_bValueChanged = false,
                     m_bFirstFocus = true,
                     m_bFocusing = false,
                     dropdownClass = options.dropdownClass.toLowerCase() + '-' + options.textHint.toLowerCase(),
                     t = (options.translate) ? options.translate : function (s) { return s; },

                     jDropdownHeaderContainer = $('<div />', {
                        html: [
                           '<label for="variInput-' + dropdownClass + '" class="sr-only">Dropdown</label>' +
                           '<input id="variInput-' + dropdownClass + '" type="text" class="foreground" />'
                        ].join(''),
                        "class": 'dropdownHeaderContainer'
                     }),

                     /**
                      * Not using the jQuery uniform library because uniform uses a REAL select box.
                      * Real select boxes can not have the click event cancelled in webkit browsers.
                      * Instead, we are piggybacking on the uniform CSS
                      */
                     jInputContainer = $(['<div class="c21textdropdown">',
                        '<div class="selector smallSelector"><span></span></div>',
                        '<label class="sr-only" for="hiddenInput-' + dropdownClass + '">Max</label>',
                        '<input id="hiddenInput-' + dropdownClass + '" type="text" class="foreground" />',
                        '</div>'].join('')),
                     jStartForeground = jDropdownHeaderContainer.find('input.foreground'),
                     jUnderlayForeground = jInputContainer.find('input.foreground'),
                     jUnderlayBackground = jInputContainer.find('span'),

                     setControlValue = function (strValue) {
                        var strHint = t(options.textHint),
                           strBackgroundText;

                        if ((strValue === "") && (strHint !== "")) {
                           strBackgroundText = strHint;
                        } else {
                           strBackgroundText = strValue;
                        }

                        jUnderlayBackground.text(strBackgroundText);
                        jUnderlayForeground.val(t(strValue));
                     },

                     setValue = function (strValue) {
                        jStartForeground.val(t(strValue));
                        setControlValue(strValue);

                        if (jHiddenInput.val() !== strValue) {
                           m_bValueChanged = true;
                        }

                        jHiddenInput.val(strValue);
                     },

                     onOptionTriggered = function () {
                        var strText = jHiddenInput.c21dropdown("getSelectedText");

                        // If an option is selected
                        if (strText) {
                           setValue(strText);
                        } else {
                           setControlValue(jStartForeground.val());
                        }

                        jStartForeground.get(0).blur();

                        jHiddenInput.c21dropdown("hideDropdown");
                     },

                     callFormatter = function () {
                        var strVal = jStartForeground.val();
                        if (strVal !== '') {
                           jHiddenInput.c21dropdown("addHeaderHighlight");
                        } else {
                           jHiddenInput.c21dropdown("removeHeaderHighlight");
                        }
                     },

                     onFocus = function () {
                        $(document).trigger('hideDropdowns');
                        jHiddenInput.c21dropdown("showAndRepositionDropdown");

                        if (!m_bFocusing) {
                           m_bFocusing = true;
                           jStartForeground.focus();
                           m_bFocusing = false;
                        }

                        if (m_bFirstFocus) {
                           m_bFirstFocus = false;
                        }
                     },

                     initialize = function () {
                        var strStartValue = options.value || jHiddenInput.val(),
                           strRandomId;

                        jHiddenInput.c21dropdown(list, {
                           headerContent: jDropdownHeaderContainer,
                           dropdownClass: options.dropdownClass,
                           appearUnderText: false,
                           translate: t,
                           onBlur: function () {
                              if (m_bValueChanged) {
                                 m_bValueChanged = false;
                                 if (options.onBlurAndChange) {
                                    options.onBlurAndChange(jHiddenInput.val());
                                 }
                              }

                              // NOTE: Fires after onBlurAndChange
                              if (options.onBlur) {
                                 options.onBlur(jHiddenInput.val());
                              }
                           },
                           hoverElement: jInputContainer,
                           relativeTo: jInputContainer,
                           onTrigger: onOptionTriggered,
                           listOptions: {
                              onOptionTriggered: onOptionTriggered
                           }
                        });

                        strRandomId = jHiddenInput.c21dropdown("getRandomId");

                        if (options.inputClass) {
                           jInputContainer.addClass(options.inputClass);
                        }

                        if (options.textHint) {
                           jUnderlayForeground.attr("placeholder", t(options.textHint));
                           jStartForeground.attr("placeholder", t(options.textHint));
                        }

                        setControlValue(strStartValue);

                        if (options.tabIndex) {
                           jStartForeground.attr('tabindex', options.tabIndex);
                        }

                        if (options.type === "text") {
                           jUnderlayBackground.hide();
                        } else {
                           jUnderlayForeground.hide();
                        }

                        if (options.maxLength) {
                           jStartForeground.attr('maxlength', options.maxLength.toString());
                        }

                        jStartForeground
                           .val(t(strStartValue))
                           .on({
                              focus: onFocus,
                              keyup: function (event) {
                                 var strValue = jStartForeground.val(),
                                    iKeyCode = event.keyCode;

                                 switch (iKeyCode) {
                                 case 13: // ENTER key
                                 case 32: // SPACE bar
                                 case 38: // UP arrow
                                 case 40: // DOWN arrow
                                    return;
                                 }

                                 callFormatter();

                                 var strNewValue = strValue.replace(/[^0-9,.$]/g, '');
                                 if (strNewValue !== strValue) {
                                    setValue(strNewValue);
                                 } else {
                                    setControlValue(strValue);
                                    if (jHiddenInput.val() !== strValue) {
                                       m_bValueChanged = true;
                                    }
                                    jHiddenInput.val(strValue);
                                 }
                              },
                              blur: function () {
                                 setTimeout(function () {
                                    /*
                                    if (!m_bClickInsideDropdown) {
                                       jHiddenInput.c21dropdown("hideDropdown");
                                    }

                                    m_bClickInsideDropdown = false;
                                    */
                                 }, 15);
                              }
                           });

                        jInputContainer.addClass(strRandomId + "_input");

                        jUnderlayBackground.on("click", onFocus);
                        jUnderlayForeground.on("focus", onFocus);

                        $.extend(data, {
                           target: jHiddenInput,
                           setValue: setValue
                        });

                        jHiddenInput
                           .after(jInputContainer).hide()
                           .data("c21textdropdown", data);
                     };

                  initialize();
               }
            });
         },

         /**
          * Determine whether this element is hidden
          */
         hidden: function () {
            return $(this).c21dropdown("hidden");
         },

         setValue: function (strValue) {
            var jHiddenInput = $(this),
               data = jHiddenInput.data("c21textdropdown");

            data.setValue(strValue);
         },

         destroy: function () {
            return this.each(function () {
               var jHiddenInput = $(this),
                  data = jHiddenInput.data('c21textdropdown');

               data.target.c21dropdown("destroy");
               data.c21textdropdown.remove();
               jHiddenInput.removeData('c21textdropdown');
            });
         }
      };

   $.fn.c21textdropdown = function (method) {
      if (methods[method]) {
         return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
      } else if (typeof method === 'object' || !method) {
         return methods.init.apply(this, arguments);
      } else {
         $.error('Method ' + method + ' does not exist on jQuery.c21textdropdown');
      }
   };
}(jQuery));
